import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import SubjectsListing from 'views/admin/subjects/SubjectsListing'
import SubjectForm from 'views/admin/subjects/SubjectForm'
import SingleSubjectInviteForm from './FormikForms/SingleSubjectInviteForm'
import SubjectTalkForm from 'views/admin/subjects/HTMLForms/SubjectTalkForm'

const Subjects = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <SubjectsListing />
      </Route>
      <Route exact path={`${path}/new`}>
        <SubjectForm />
      </Route>
      <Route exact path={`${path}/invite`}>
        <SingleSubjectInviteForm />
      </Route>
      <Route exact path={`${path}/edit/:subjectId`}>
        <SubjectForm />
      </Route>
      <Route exact path={`${path}/edit/:subjectId/talks/:talkId`}>
        <SubjectTalkForm forApproval={true} />
      </Route>
    </Switch>
  )
}

export default Subjects
